module.exports = __webpack_public_path__ + "img/8_Proximal Transverse Colon.caaf6d05.png";